import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "header-label"
};
const _hoisted_2 = {
    key: 0,
    class: "empty-state"
};
const _hoisted_3 = { class: "empty-text" };
const _hoisted_4 = {
    key: 1,
    class: "scroll-area"
};
const _hoisted_5 = {
    key: 0,
    class: "search-bar"
};
const _hoisted_6 = { class: "row items-start no-wrap q-px-sm q-py-xs list-item" };
const _hoisted_7 = { class: "column col" };
const _hoisted_8 = { class: "text-subtitle1 text-weight-medium ellipsis-2-lines" };
const _hoisted_9 = { class: "text-body1 text-weight-medium" };
const _hoisted_10 = { class: "text-body2 text-grey-7" };
const _hoisted_11 = {
    key: 2,
    class: "q-pa-md flex flex-center"
};
const _hoisted_12 = {
    key: 3,
    class: "q-pa-md flex flex-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_space = _resolveComponent("q-space");
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_bar = _resolveComponent("q-bar");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_input = _resolveComponent("q-input");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_checkbox = _resolveComponent("q-checkbox");
    const _component_q_drawer = _resolveComponent("q-drawer");
    return (_openBlock(), _createBlock(_component_q_drawer, {
        modelValue: _ctx.drawerModel,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.drawerModel) = $event)),
        side: "right",
        overlay: "",
        elevated: "",
        width: 400,
        class: "relative-position"
    }, {
        default: _withCtx(() => [
            _createVNode(_component_q_bar, { class: "bg-white justify-between" }, {
                default: _withCtx(() => [
                    (_ctx.selected.length === 0 || _ctx.bulkRoom)
                        ? (_openBlock(), _createBlock(_component_q_space, { key: 0 }))
                        : (_openBlock(), _createElementBlock("div", _hoisted_1, " 追加可能な入居者を表示中 ")),
                    _createVNode(_component_q_icon, {
                        class: "cursor-pointer",
                        size: "2.0em",
                        name: "close",
                        color: "grey-7",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.drawerModel = false))
                    })
                ]),
                _: 1
            }),
            (_ctx.selected.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_q_separator),
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.noDataLabel), 1),
                    _createVNode(_component_q_separator)
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (!_ctx.bulkRoom)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_q_input, {
                                class: "col",
                                dense: "",
                                outlined: "",
                                modelValue: _ctx.inputValue,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.inputValue) = $event)),
                                placeholder: "物件名/号室/入居者名",
                                clearable: "",
                                "clear-icon": "close"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_q_btn, {
                                icon: "search",
                                color: "green-7",
                                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.applyFilter()))
                            })
                        ]))
                        : _createCommentVNode("", true),
                    _createVNode(_component_q_separator),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedRooms, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: item.orgNyukyokeiyakuNo
                        }, [
                            _createElementVNode("div", _hoisted_6, [
                                (!_ctx.bulkRoom)
                                    ? (_openBlock(), _createBlock(_component_q_checkbox, {
                                        key: 0,
                                        modelValue: _ctx.selectedRooms,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.selectedRooms) = $event)),
                                        val: item,
                                        color: "green",
                                        size: "sm",
                                        class: "q-mr-xs"
                                    }, null, 8, ["modelValue", "val"]))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_q_icon, {
                                    class: "q-mr-sm q-mt-xs",
                                    size: "1.5em",
                                    name: item.roomSb === _ctx.RoomSb.Parking ? 'directions_car' : 'maps_home_work',
                                    color: "grey-7"
                                }, null, 8, ["name"]),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, _toDisplayString(item.bukkenName), 1),
                                    _createElementVNode("div", _hoisted_9, _toDisplayString(item.roomNumber), 1),
                                    _createElementVNode("div", _hoisted_10, _toDisplayString(item.nyukyosha), 1)
                                ]),
                                (_ctx.showDelete)
                                    ? (_openBlock(), _createBlock(_component_q_icon, {
                                        key: 1,
                                        class: "cursor-pointer q-ml-sm q-mt-xs",
                                        size: "1.4em",
                                        name: "delete",
                                        color: "red",
                                        onClick: ($event) => (_ctx.$emit('delete', item))
                                    }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_q_separator)
                        ]));
                    }), 128))
                ])),
            (_ctx.bulkRoom)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_ctx.selected.length > 0)
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 0,
                            label: "申請入力へ",
                            color: "green-7",
                            "icon-right": "navigate_next",
                            onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.$emit('submit')))
                        }))
                        : _createCommentVNode("", true)
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_ctx.selected.length > 0)
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 0,
                            label: "追加",
                            color: "green-7",
                            onClick: _ctx.onAdd
                        }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                ]))
        ]),
        _: 1
    }, 8, ["modelValue"]));
}
